import React, { useState, forwardRef, useImperativeHandle } from "react";
import { flushSync } from "react-dom";
import { CSVLink } from "react-csv";
import { jsonToDotNotation } from "../../../utils/reusedFunctions";

const ExportToCSV = forwardRef((props, ref) => {
  const [updatedData, setUpdatedData] = useState<Array<any>>([]);
  const [nameOfFile, setNameOfFile] = useState<string>("");

  useImperativeHandle(ref, () => ({
    onDownload(data, nameOfFile) {
      const convertedObj: any = jsonToDotNotation(data);
      // The link must be rendered with the new data before clicking it, or the click hits no link or the previous export
      flushSync(() => {
        setUpdatedData(convertedObj);
        setNameOfFile(nameOfFile);
      });

      document.getElementById("csv")?.click();
    },
  }));

  return (
    <>
      {updatedData?.length > 0 && (
        <CSVLink
          id="csv"
          data={updatedData}
          filename={nameOfFile}
          separator={","}
        ></CSVLink>
      )}
    </>
  );
});

ExportToCSV.displayName = "ExportToCSV";

export default ExportToCSV;
